import { all } from "redux-saga/effects";
import watchLogin from "./login";
import watchUserInfo from "./userInfo";

export default function* sagas() {
  yield all([watchLogin(), watchUserInfo()]);
}
